import React from "react";
import "../styles/skilledInvisible.css";

import Footer from "../components/Footer";
import SkilledInvisibleContent from "../components/SkilledInvisibleContent";

import HeroSkilledInvisible from "../assets/img/skilledInvisible/heroSkilledInvisible.png";

import { Link } from "react-router-dom";

const SkilledInvisible = () => {
  return (
    <>
      <Link to="/" className="back-to-main back-to-main--white">
        POWRÓT DO STRONY GŁÓWNEJ
      </Link>
      <img
        className="hero-skilled-invisible"
        alt="Zdolni niewidzialni"
        src={HeroSkilledInvisible}
      />

      <SkilledInvisibleContent />
      <Footer />
    </>
  );
};
export default SkilledInvisible;
